import React, { useState, useEffect } from 'react';
import './App.css';
import GoldPriceChart from './components/GoldPriceChart';
import PredictionForm from './components/PredictionForm';
import PredictionResult from './components/PredictionResult';
import HistoricalDataTable from './components/HistoricalDataTable';
import { getHistoricalData, getPrediction } from './services/goldPriceService';

function App() {
  const [historicalData, setHistoricalData] = useState([]);
  const [predictedData, setPredictedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [predicting, setPredicting] = useState(false);
  const [showPrediction, setShowPrediction] = useState(false);
  const [selectedRange, setSelectedRange] = useState({ start: 0, end: 0 });

  // Default date range (last month to today)
  const defaultStartDate = (() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];
  })();
  
  const defaultEndDate = new Date().toISOString().split('T')[0];

  // Fetch historical gold price data
  const fetchHistoricalData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const data = await getHistoricalData(startDate, endDate);
      setHistoricalData(data);
      setSelectedRange({ start: 0, end: data.length - 1 });
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch historical data:', error);
      setLoading(false);
    }
  };

  // Initial data load
  useEffect(() => {
    fetchHistoricalData(defaultStartDate, defaultEndDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle range change from chart slider
  const handleRangeChange = (startIndex, endIndex) => {
    setSelectedRange({ start: startIndex, end: endIndex });
  };

  const handlePredict = async (days, startDate, endDate) => {
    try {
      setPredicting(true);
      setShowPrediction(false);
      
      // First update historical data with new date range
      await fetchHistoricalData(startDate, endDate);
      
      // Then get prediction data
      const prediction = await getPrediction(days);
      setPredictedData(prediction);
      
      setShowPrediction(true);
      setPredicting(false);
    } catch (error) {
      console.error('Failed to generate prediction:', error);
      setPredicting(false);
    }
  };

  // Get filtered data based on selected range
  const getFilteredData = () => {
    return historicalData.slice(selectedRange.start, selectedRange.end + 1);
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1 className="app-title">Gold Price Prediction</h1>
        <p className="app-subtitle">Analyze and predict 8g gold prices in Indian Rupees</p>
      </header>

      <div className="main-content">
        {loading ? (
          <div className="loading">Loading historical data...</div>
        ) : (
          <>
            <GoldPriceChart 
              data={historicalData} 
              onRangeChange={handleRangeChange}
            />
            
            <HistoricalDataTable data={getFilteredData()} />
            
            <PredictionForm onPredict={handlePredict} />

            {predicting && <div className="loading">Generating prediction...</div>}

            {showPrediction && !predicting && (
              <PredictionResult 
                historicalData={getFilteredData()} 
                predictedData={predictedData} 
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default App;